import { AuthStore } from './AuthStore';
import { RoomStore } from './RoomStore';
import { RoundStore } from './RoundStore';
import { MatchStore } from './MatchStore';
import { UiStore } from './UiStore';
import { OnboardingStore } from './OnboardingStore';
import { ProfileStore } from './ProfileStore';
import { PrefsStore } from './PrefsStore';
import { fx } from '@/platform/feedback';

export class RootStore {
  readonly auth = new AuthStore(this);
  readonly room = new RoomStore(this);
  readonly round = new RoundStore(this);
  readonly match = new MatchStore(this);
  readonly ui = new UiStore(this);
  readonly onboarding = new OnboardingStore();
  readonly profile = new ProfileStore(this);
  readonly prefs = new PrefsStore();
}

export const rootStore = new RootStore();
fx.init(rootStore.prefs);
